var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppointmentBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.29166C8.73439 2.29166 7.70837 3.31768 7.70837 4.58333C7.70837 5.84898 8.73439 6.875 10 6.875C11.2657 6.875 12.2917 5.84898 12.2917 4.58333C12.2917 3.31768 11.2657 2.29166 10 2.29166ZM6.45837 4.58333C6.45837 2.62732 8.04403 1.04166 10 1.04166C11.956 1.04166 13.5417 2.62732 13.5417 4.58333C13.5417 6.53934 11.956 8.125 10 8.125C8.04403 8.125 6.45837 6.53934 6.45837 4.58333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16663 11.0417C5.29844 11.0417 2.29163 13.8138 2.29163 17.0833C2.29163 17.4285 2.0118 17.7083 1.66663 17.7083C1.32145 17.7083 1.04163 17.4285 1.04163 17.0833C1.04163 12.9891 4.75056 9.79166 9.16663 9.79166C9.5118 9.79166 9.79163 10.0715 9.79163 10.4167C9.79163 10.7618 9.5118 11.0417 9.16663 11.0417Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1666 11.0417C12.4407 11.0417 11.0416 12.4408 11.0416 14.1667C11.0416 15.8926 12.4407 17.2917 14.1666 17.2917C15.8925 17.2917 17.2916 15.8926 17.2916 14.1667C17.2916 12.4408 15.8925 11.0417 14.1666 11.0417ZM9.79163 14.1667C9.79163 11.7504 11.7504 9.79166 14.1666 9.79166C16.5829 9.79166 18.5416 11.7504 18.5416 14.1667C18.5416 16.5829 16.5829 18.5417 14.1666 18.5417C11.7504 18.5417 9.79163 16.5829 9.79163 14.1667Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 12.2917C14.0952 12.2917 14.375 12.5715 14.375 12.9167V13.9583H15.4167C15.7618 13.9583 16.0417 14.2382 16.0417 14.5833C16.0417 14.9285 15.7618 15.2083 15.4167 15.2083H13.75C13.4048 15.2083 13.125 14.9285 13.125 14.5833V12.9167C13.125 12.5715 13.4048 12.2917 13.75 12.2917Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentBlack);
export default __webpack_public_path__ + "static/media/appointment-black.fd3d3a4f4c6d50028a42534d8318abbd.svg";
export { ForwardRef as ReactComponent };